import { Redirect, useLocalSearchParams } from 'expo-router';

import { AuthContainer, VerifyOtp } from '@fhs/auth';

export default function VerifyOtpPage() {
  const { loginJwt } = useLocalSearchParams<{ loginJwt?: string }>();
  if (!loginJwt) {
    return <Redirect href="/v2/signin" />;
  }
  return (
    <AuthContainer>
      <VerifyOtp />
    </AuthContainer>
  );
}
